export const formatActivityTime = (timestamp: number): string => {
  const now = Date.now();
  const diff = now - timestamp;
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) {
    return `${days} day${days === 1 ? '' : 's'} ago`;
  } else if (hours > 0) {
    return `${hours} hour${hours === 1 ? '' : 's'} ago`;
  } else if (minutes > 0) {
    return `${minutes} minute${minutes === 1 ? '' : 's'} ago`;
  } else {
    return 'Just now';
  }
};

export const getActivityIcon = (type: string): string => {
  switch (type) {
    case 'team_joined':
      return '👥';
    case 'design_created':
      return '🎨';
    case 'moodboard_created':
      return '📋';
    case 'collaboration_started':
      return '🤝';
    case 'design_updated':
      return '✏️';
    default:
      return '📝';
  }
}; 